import { createSlice } from '@reduxjs/toolkit'

export const chronology = createSlice({
  name: 'chronology',
  initialState: {
    list: {}
  },
  reducers: {
    pushChron: (state, action) => {
      if (action.payload.id in state.list) {
        state.list[action.payload.id].time++
        state.list[action.payload.id].date = Math.round((new Date()).getTime() / 1000)
      }
      else
      {
        state.list[action.payload.id] = {
          time: 1,
          city: action.payload,
          date: Math.round((new Date()).getTime() / 1000)
        }
      }
    },
    deleteChron: (state) => {
      state.list = {}
    }
  },
})

// Action creators are generated for each case reducer function
export const { pushChron, deleteChron } = chronology.actions

export default chronology.reducer